import styled from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';

const styles = {
  formContainer: {
    display: 'flex',
    alignItems: 'center',
    margin: '20px 15px',
  },
  formEmail: {
    display: 'flex',
    alignItems: 'center',
    margin: '5px 15px',
  },
  input: {
    width: '300px',
    fontFamily: 'Nunito , sans-serif',
  },
  text: {
    fontSize: '18px',
    fontFamily: 'Nunito , sans-serif',
    margin: '15px 15px 3px',
  },
};

export const Button = styled.button`
  transition: all 0.5s ease-in-out;
  background-color: #FFA500;
  border: none;
  border-radius: 5px;
  color: white;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  font-family: 'Nunito', sans-serif;
  width: 250px;
  height: 55px;
  letter-spacing: 1px;
  margin: 10px 5px;
  &:hover {
    background-color: #FFA555;
    border-color: #fff;
  }
}
`;

export const useStyles = makeStyles(styles);
